import React from 'react';
import { Banknote, CreditCard, Nfc } from 'lucide-react';

// Elfogadott fizetési módok – EGY forrás, hogy ne csússzon szét oldalanként.
// A fizetés minden esetben az ÜZLETBEN történik (nincs online fizetés), ezért
// a felsorolás a bolti terminálra vonatkozik.
export const PAYMENT_METHODS = [
  { key: 'cash', label: 'Készpénz', Icon: Banknote },
  { key: 'card', label: 'Bankkártya', Icon: CreditCard },
  // Apple/Google Pay: érintéses (NFC) fizetés a telefonnal. SZÁNDÉKOSAN nincs
  // márka-logó: a hivatalos jelzések használata külön feltételekhez kötött, és
  // az Apple-logó karaktere () csak Apple-eszközön jelenik meg – Androidon
  // üres helyet hagyna. A szöveges megnevezés önmagában egyértelmű.
  { key: 'apple', label: 'Apple Pay', Icon: Nfc },
  { key: 'google', label: 'Google Pay', Icon: Nfc },
];

/**
 * Elfogadott fizetési módok.
 *
 * @param variant  'inline' – kompakt sor (termékoldal, szerviz árlista alá)
 *                 'card'   – kártyás blokk címmel (üzletek oldal)
 * @param note     opcionális kiegészítő mondat a lista alatt
 */
export default function PaymentMethods({ variant = 'inline', note, className = '' }) {
  const items = (
    <ul className="flex flex-wrap items-center gap-x-3 gap-y-2" data-testid="payment-methods">
      {PAYMENT_METHODS.map(({ key, label, Icon }) => (
        <li
          key={key}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-gray-200 bg-white text-sm text-gray-700"
        >
          <Icon size={16} className="text-brand flex-shrink-0" aria-hidden="true" />
          <span className="font-medium">{label}</span>
        </li>
      ))}
    </ul>
  );

  if (variant === 'card') {
    return (
      <div className={`rounded-2xl border border-gray-200 bg-white p-5 ${className}`}>
        <h2 className="font-bold text-ink mb-3">Így fizethetsz nálunk</h2>
        {items}
        {note && <p className="mt-3 text-xs text-gray-500 leading-relaxed">{note}</p>}
      </div>
    );
  }

  return (
    <div className={className}>
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">Fizetés</p>
      {items}
      {note && <p className="mt-2 text-xs text-gray-500 leading-relaxed">{note}</p>}
    </div>
  );
}
